// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uFPnj.ui.popup{box-shadow:0 1px 3px 0 #00000014;margin:.25rem 0 0;max-height:15rem;overflow-y:auto;padding:.75rem 1rem}.uFPnj.ui.popup .content>div{padding-bottom:.5rem}.uFPnj.ui.popup .content>div:last-child{padding-bottom:0}._BZqE{display:flex;gap:.25rem;width:100%}._BZqE .awNyX{align-self:center;color:#2185d0;cursor:pointer;flex-shrink:0;font-size:.85rem;white-space:nowrap}._BZqE .ukTu0{margin-right:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `uFPnj`,
	"list": `_BZqE`,
	"andXMore": `awNyX`,
	"listItemLabel": `ukTu0`
};
module.exports = ___CSS_LOADER_EXPORT___;
